module.exports = __webpack_public_path__ + "media/images/card-2-2f9ae5db3e26a7cd4616461931a29f47.jpg";